import { Button, HighlightIcon } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import './MarqetaSetPinSuccess.css';

type Props = {
  onClose(): void;
};

export const MarqetaSetPinSuccess = ({ onClose }: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="MarqetaSetPinSuccess">
      <HighlightIcon
        name="circle-check"
        variant="success"
        className="MarqetaSetPinSuccess__image"
      />
      <div className="MarqetaSetPinSuccess__message">
        {t('cards.setPinWidget.success')}
      </div>
      <Button
        text={t('cards.setPinWidget.continue')}
        className="MarqetaSetPinSuccess__button"
        onClick={onClose}
      />
    </div>
  );
};
